"use client";

import * as React from "react";
import { Checkbox } from "@baluu/ui/components/checkbox";
import { Label } from "@baluu/ui/components/label";
import { cn } from "@baluu/ui/lib/utils";

export type MandatoryAcceptanceCheckboxProps = {
  id?: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  onOpenTerms: () => void;
  touched?: boolean;
  disabled?: boolean;
  className?: string;
};

export function MandatoryAcceptanceCheckbox({
  id = "mandatoryTickBox",
  checked,
  onCheckedChange,
  onOpenTerms,
  touched = false,
  disabled = false,
  className,
}: MandatoryAcceptanceCheckboxProps) {
  return (
    <div
      className={cn(
        "p-4 bg-muted rounded-lg border-2 border-border",
        className,
      )}
    >
      <div className="flex items-start gap-3">
        <Checkbox
          id={id}
          checked={checked}
          onCheckedChange={(value) => onCheckedChange(value === true)}
          disabled={disabled}
          className="h-5 w-5 mt-0.5 shrink-0 border-2"
        />
        <Label
          htmlFor={id}
          className="block text-sm sm:text-base text-foreground font-normal cursor-pointer leading-relaxed"
        >
          I agree to the{" "}
          <button
            type="button"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onOpenTerms();
            }}
            className="text-primary font-semibold underline underline-offset-2 hover:text-primary/80"
          >
            terms and conditions
          </button>{" "}
          for this purchase. <span className="text-destructive">*</span>
        </Label>
      </div>
      {touched && !checked && (
        <p className="text-sm text-destructive mt-2 ml-8">
          Please accept the terms and conditions to continue
        </p>
      )}
    </div>
  );
}
